import { IQueryContext } from 'framework/context/IQueryContext';
import { IArticlesInquiriesMetadata, IArticlesInquiriesQueryParams, IArticlesInquiry, IQueryResultWithMetadata } from 'gen/ApiClient';
import React from 'react';

export const ArticlesInquiriesQueryContext = React.createContext<
	IQueryContext<IQueryResultWithMetadata<IArticlesInquiry, IArticlesInquiriesMetadata>, IArticlesInquiriesQueryParams>
>(undefined as any);
